export enum ETipoDetalhamentoTituloFinanceiro {
    Informativo = 1,
    Abatimento = 2,
    IssRetido = 3,
  }
